import LAYOUT_CONST from 'constant';

export const BASE_PATH = '';

export const DASHBOARD_PATH = '/';

export const HORIZONTAL_MAX_ITEM = 6;

export const AXIOS_BASE_URL = 'https://192.168.72.129';

export const APP_VERSION = '2.0.0';

const config = {
    layout: LAYOUT_CONST.VERTICAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'IRANSans', 'Roboto'`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'dark', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'ir', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: true,
    container: false
};

export default config;
